/* eslint-disable max-len */
import discoverPlace from 'api/discoverPlace';
import images from 'assets/images';
import classNames from 'classnames/bind';
import Button from 'components/App/Button';
import Card from 'components/App/Card';
import IconStarDiscovery from 'components/App/IconStarDiscovery';
import InputValidation from 'components/App/InputValidation';
import SelectValidation from 'components/App/SelectValidation';
import ModalRequestAction from 'components/Modals/ModalRequestAction';
import Pagination from 'components/Pagination';
import ENDPOINT from 'constants/endPoint';
import { themeColor } from 'constants/index';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Col, Label, Modal, Nav, NavItem, NavLink, Row, Spinner, Table } from 'reactstrap';
import {
  actionCleanupDiscoverPlaceList as actionCleanupDiscoverPlaceListAction,
  actionGetDiscoverPlaceList as actionGetDiscoverPlaceListAction,
} from 'store/actions';
import {
  actionCleanupDiscoveryCategories as actionCleanupDiscoveryCategoriesAction, actionGetDiscoveryCategories as actionGetDiscoveryCategoriesAction,
} from 'store/discover-category/actions';
import { apiErrorHandler, filterAllValueObject, getTotalReviewCount, isMongoId, showSuccess } from 'utils';
import ModalAddPlace from '../ModalAddPlace';
import styles from './styles.modules.scss';

const cx = classNames.bind(styles);

const TAB = {
  ALL: 'ALL',
};

const RATING_OPTIONS = [
  {
    label: '1 sao',
    value: 1,
  },
  {
    label: '2 sao',
    value: 2,
  },
  {
    label: '3 sao',
    value: 3,
  },
  {
    label: '4 sao',
    value: 4,
  },
  {
    label: '5 sao',
    value: 5,
  },
];

const LIMIT = 10;

function DiscoverPlaces(props) {
  const {
    provinceDetails,
    //
    discoverPlaceList,
    discoverPlaceListLoading,
    actionGetDiscoverPlaceList,
    actionCleanupDiscoverPlaceList,

    actionCleanupDiscoveryCategories,
    actionGetDiscoveryCategories,
    // eslint-disable-next-line no-unused-vars
    categories,
    // eslint-disable-next-line no-unused-vars
    categoriesLoading,
  } = props;
  const totalPage = useMemo(() => Math.ceil(discoverPlaceList.total / LIMIT), [discoverPlaceList.total]);

  const { id } = useParams();

  const [isOpenModalAddPlace, setIsOpenModalAddPlace] = useState(false);
  const [isOpenModalRequestAction, setIsOpenModalRequestAction] = useState(false);
  const [idItemRequestAction, setIdItemRequestAction] = useState(null);
  const [isLoadingConfirm, setIsLoadingConfirm] = useState(false);

  const validation = useFormik({
    initialValues: {
      q: '',
      discoverCategories: TAB.ALL,
      rating: '',
      page: 1,
      limit: LIMIT,
    },
    onSubmit: (values) => {
      actionGetDiscoverPlaceList(filterAllValueObject({
        discoverCategories: values.discoverCategories,
        discoverProvince: id,
        limit: LIMIT,
        page: 1,
        q: values.q,
        rating: values.rating,
      }));
    },
  });

  const discoverCategories = useMemo(() =>
    provinceDetails
      .discoverCategories
      .map((category) => ({
        value: category._id,
        label: category.name,
      })), [provinceDetails.discoverCategories]);

  const NAV_TAB = useMemo(() => [
    { title: 'Tất cả', value: TAB.ALL },
    ...discoverCategories.map((category) => ({
      title: category.label,
      value: category.value,
    })),
  ], [discoverCategories]);

  const onRefreshData = useCallback(() => {
    actionGetDiscoverPlaceList(filterAllValueObject({
      discoverCategories: validation.values.discoverCategories,
      discoverProvince: id,
      limit: LIMIT,
      page: validation.values.page,
      q: validation.values.q,
      rating: validation.values.rating,
    }));
  }, [
    actionGetDiscoverPlaceList,
    id,
    validation.values.discoverCategories,
    validation.values.page,
    validation.values.q,
    validation.values.rating,
  ]);

  const onChangeTab = useCallback((tab) => () => {
    validation.setFieldValue('discoverCategories', tab, true);

    actionGetDiscoverPlaceList(filterAllValueObject({
      discoverCategories: tab,
      discoverProvince: id,
      limit: LIMIT,
      page: 1,
      q: validation.values.q,
      rating: validation.values.rating,
    }));
  }, [actionGetDiscoverPlaceList, id, validation]);

  const columns = useMemo(() => [
    {
      header: 'Điểm khám phá',
      render: (item) => (
        <div className={cx('TdItem')}>
          <div className="fw-medium">
            {item.name}
          </div>

          <div className={cx('Action')}>
            <button
              type="button"
              className="custom-action-button danger"
              onClick={() => {
                setIdItemRequestAction(item._id);
                setIsOpenModalRequestAction(true);
              }}
            >
              Xoá
            </button>

            <Link to={ENDPOINT.MANAGER_DISCOVERY_PLACE_DETAIL(item._id)}>
              <button
                type="button"
                className="custom-action-button link"
              >
                Xem chi tiết
              </button>
            </Link>
          </div>

        </div>
      ),
    },
    {
      header: 'Địa chỉ',
      render: (item) => (
        <div>
          {[
            isMongoId(item.address) ? null : item.address,
            isMongoId(item.ward) ? null : item.ward,
            isMongoId(item.district) ? null : item.district,
            isMongoId(item.province) ? null : item.province,
          ].filter(Boolean).join(', ')}
        </div>
      ),
    },
    {
      header: 'Hạng mục',
      render: (item) => (
        <div className="d-flex gap-2">
          {item.discoverCategories.map((category) => (
            <p key={category._id}>
              {category.name}
            </p>
          ))}
        </div>
      ),
    },
    {
      header: 'Điểm đến',
      render: (item) => (
        <div>
          {item.discoverProvince.name}
        </div>
      ),
    },
    {
      header: 'Điểm đánh giá',
      render: (item) => (
        <div>
          <IconStarDiscovery star={item.ratingOverview ?? 0} size={12} />
        </div>
      ),
    },
    {
      header: 'Tổng lượt đánh giá',
      render: (item) => (
        <div>
          {getTotalReviewCount(item)}
        </div>
      ),
    },
  ], []);

  useEffect(() => {
    // One time get data
    actionGetDiscoveryCategories({
      limit: 1000,
      page: 1,
    });

    actionGetDiscoverPlaceList({
      discoverProvince: id,
      limit: LIMIT,
      page: 1,
    });
  }, [
    actionGetDiscoverPlaceList,
    actionGetDiscoveryCategories,
    id,
  ]);

  useEffect(() => () => {
    // Cleanup
    actionCleanupDiscoveryCategories();
    actionCleanupDiscoverPlaceList();
  }, [actionCleanupDiscoverPlaceList, actionCleanupDiscoveryCategories]);

  return (
    <>
      <Card className={cx('Card')}>
        <Row>
          <Col md="6" className="mb-24">
            <div className="col-md-11">
              <Label>
                Tìm kiếm điểm khám phá
              </Label>

              <div className="position-relative">
                <InputValidation
                  name="q"
                  placeholder="Tìm kiếm điểm khám phá"
                  validation={validation}
                  style={{ paddingLeft: '36px' }}
                />

                <i className="fas fa-search position-absolute top-50 start-0 translate-middle-y ms-3" style={{ color: 'var(--bookese-gray-300)' }} />
              </div>
            </div>
          </Col>

          <Col md="6">
            <div>
              <Label>
                Bộ lọc
              </Label>

              <Row>
                {/* <Col md="6" className="mb-24">
                  <SelectValidation
                    name="category"
                    options={categories.data.map((item) => ({
                      value: item._id,
                      label: item.name,
                    }))}
                    isDisabled={categoriesLoading}
                    placeholder="Hạng mục"
                    validation={validation}
                    value={validation.values.category}
                    onChange={(e) => {
                      validation.setFieldValue('category', e.value);
                    }}
                    isHiddenClearable
                  />
                </Col> */}

                <Col md="6" className="mb-24">
                  <SelectValidation
                    name="rating"
                    options={RATING_OPTIONS}
                    placeholder="Điểm đánh giá"
                    validation={validation}
                    value={validation.values.rating}
                    onChange={(e) => {
                      validation.setFieldValue('rating', e.value);
                    }}
                    isHiddenClearable
                  />
                </Col>
              </Row>
            </div>
          </Col>

          <Col md="12">
            <div className="d-flex gap-4">
              <Button
                color={themeColor.SECONDARY}
                outline
                onClick={() => {
                  validation.resetForm({
                    values: {
                      discoverCategories: TAB.ALL,
                      limit: LIMIT,
                      page: 1,
                      q: '',
                      rating: '',
                    },
                  });

                  actionGetDiscoverPlaceList(filterAllValueObject({
                    discoverCategories: TAB.ALL,
                    discoverProvince: id,
                    limit: LIMIT,
                    page: 1,
                    q: '',
                    rating: '',
                  }));
                }}
              >
                Nhập lại
              </Button>

              <Button
                color={themeColor.PRIMARY}
                onClick={() => {
                  validation.handleSubmit();
                }}
              >
                Tìm kiếm
              </Button>
            </div>
          </Col>
        </Row>
      </Card>

      <Card className={cx('Card')}>
        <div className="custom_pills">
          <div className="d-flex flex-column flex-md-row justify-content-between align-md-items-center gap-4">
            <Nav pills style={{ flex: 1 }}>
              {NAV_TAB.map((tab) => (
                <NavItem key={tab.value}>
                  <NavLink
                    className={
                      validation.values.discoverCategories === tab.value
                        ? 'active'
                        : ''
                    }
                    onClick={onChangeTab(tab.value)}
                  >
                    <span>{tab.title}</span>
                  </NavLink>
                </NavItem>
              ))}
            </Nav>

            <button
              type="button"
              className={cx('Button')}
              onClick={() => setIsOpenModalAddPlace(true)}
            >
              <i className="fas fa-plus" />
              {' '}
              Thêm điểm khám phá
            </button>
          </div>
        </div>

        <div className={cx('Total')}>
          {discoverPlaceList.total}
          {' '}
          điểm khám phá
        </div>

        <div className="position-relative">
          {discoverPlaceListLoading && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
              zIndex: 10,
            }}
            >
              <Spinner />
            </div>
          )
          }

          <Table responsive className="custom_table">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.header}>{column.header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {discoverPlaceList.data.map((item) => (
                <tr key={item._id}>
                  {columns.map((column) => (
                    <td key={column.header}>{column.render(item)}</td>
                  ))}
                </tr>
              ))}

              {discoverPlaceList.data.length === 0 && (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="text-center"
                  >
                    Không có dữ liệu
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <Pagination
            page={validation.values.page}
            pageCount={totalPage}
            onChangePage={({ selected }) => {
              const page = selected + 1;

              validation.setFieldValue('page', page);

              actionGetDiscoverPlaceList(filterAllValueObject({
                page,
                limit: LIMIT,
                discoverProvince: id,
                rating: validation.values.rating,
                discoverCategories: validation.values.discoverCategories,
                q: validation.values.q,
              }));
            }}
          />
        </div>
      </Card>

      {/* Modal Add Discover Place */}
      <Modal
        isOpen={isOpenModalAddPlace}
        size="lg"
        style={{ maxWidth: '779px' }}
        fade
        toggle={() => setIsOpenModalAddPlace((prev) => !prev)}
      >
        <ModalAddPlace
          provinceId={id}
          onRefreshData={onRefreshData}
          discoverCategories={discoverCategories}
          onClose={() => setIsOpenModalAddPlace(false)}
        />
      </Modal>

      <ModalRequestAction
        isOpen={isOpenModalRequestAction}
        onClose={() => {
          setIsOpenModalRequestAction(false);
          setIdItemRequestAction(null);
        }}
        onConfirm={async () => {
          setIsLoadingConfirm(true);

          try {
            await discoverPlace.updateDiscoverPlaceDiscoverProvince(idItemRequestAction, {
              discoverProvince: null,
            });

            showSuccess('Xoá điểm khám phá thành công');

            onRefreshData();

            if (isOpenModalRequestAction) {
              setIsOpenModalRequestAction(false);
              setIdItemRequestAction(null);
            }
          } catch (error) {
            apiErrorHandler(error, true);
          } finally {
            setIsLoadingConfirm(false);
          }
        }}
        isLoadingConfirm={isLoadingConfirm}
        icon={images.modalGarbageCan.default}
        textRequest={'Bạn có chắc chắn muốn xóa \n điểm khám phá này không?'}
      />
    </ >
  );
}

const mapStateToProps = (state) => ({
  categories: state.DiscoverCategory.categories,
  categoriesLoading: state.DiscoverCategory.categoriesLoading,
  discoverPlaceList: state.DiscoverPlace.discoverPlaceList,
  discoverPlaceListLoading: state.DiscoverPlace.discoverPlaceListLoading,
});

const mapDispatchToProps = ({
  actionCleanupDiscoverPlaceList: actionCleanupDiscoverPlaceListAction,
  actionCleanupDiscoveryCategories: actionCleanupDiscoveryCategoriesAction,
  actionGetDiscoverPlaceList: actionGetDiscoverPlaceListAction,
  actionGetDiscoveryCategories: actionGetDiscoveryCategoriesAction,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscoverPlaces);

DiscoverPlaces.propTypes = {
  actionCleanupDiscoverPlaceList: PropTypes.func.isRequired,
  actionCleanupDiscoveryCategories: PropTypes.func.isRequired,
  actionGetDiscoverPlaceList: PropTypes.func.isRequired,
  actionGetDiscoveryCategories: PropTypes.func.isRequired,
  categories: PropTypes.instanceOf(Array).isRequired,
  categoriesLoading: PropTypes.bool.isRequired,
  discoverPlaceList: PropTypes.instanceOf(Object).isRequired,
  discoverPlaceListLoading: PropTypes.bool.isRequired,
  provinceDetails: PropTypes.instanceOf(Object).isRequired,
};
